"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icons_1 = __importDefault(require("@ant-design/icons"));
var antd_1 = require("antd");
var ControlBarButton_1 = __importDefault(require("./ControlBarButton"));
var ColorPicker_1 = require("../../ColorPicker");
var transifex_1 = require("../../../transifex");
var DEFAULT_COLOR = "#000000";
var BackgroundColor = function (_a) {
    var editorState = _a.editorState, onColorChange = _a.onColorChange;
    var currentColor = null;
    var selectionStyles = editorState.getCurrentInlineStyle().toJS();
    selectionStyles.forEach(function (style) {
        if (style.indexOf("BGCOLOR-") === 0) {
            currentColor = "#" + style.split("-")[1];
        }
    });
    if (!currentColor) {
        currentColor = DEFAULT_COLOR;
    }
    return (react_1.default.createElement(antd_1.Dropdown, { placement: "top", overlay: react_1.default.createElement(ColorPicker_1.ColorPicker, { value: currentColor, onChange: onColorChange }), trigger: ["click"] },
        react_1.default.createElement(ControlBarButton_1.default, { color: currentColor, tooltip: transifex_1.TX_BACKGROUND_COLOR, icon: react_1.default.createElement(icons_1.default, { component: function () { return (react_1.default.createElement("svg", { style: { height: 15, width: 14 }, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12.5 13" },
                    react_1.default.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
                        react_1.default.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" },
                            react_1.default.createElement("path", { d: "M10.22,10.38a1.26,1.26,0,0,0,1.25-1.26c0-.84-1.25-2.2-1.25-2.2S9,8.28,9,9.12A1.26,1.26,0,0,0,10.22,10.38Z" }),
                            react_1.default.createElement("path", { d: "M4.33,9.69a.28.28,0,0,0,.4,0l4-4a.27.27,0,0,0,0-.4l-4-4,0,0L3.48,0a.14.14,0,0,0-.2,0L2.53.79a.13.13,0,0,0,0,.1.13.13,0,0,0,0,.1L3.58,2,.33,5.29a.28.28,0,0,0,0,.4Zm.2-7,2.8,2.8H1.74Z" }),
                            react_1.default.createElement("rect", { 
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                style: { fill: currentColor }, y: "11.5", width: "12.5", height: "1.5", rx: "0.13" }))))); } }) })));
};
exports.default = BackgroundColor;
